import { render, staticRenderFns } from "./DestinoEcopetrolExport.vue?vue&type=template&id=2c33c0d4"
import script from "./DestinoEcopetrolExport.vue?vue&type=script&lang=js"
export * from "./DestinoEcopetrolExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports